module.exports = __webpack_public_path__ + "f048e3705f0679e4292b3628d4a69dca.pdf";